interface TabProps {
  active?: boolean
  text: string
  Icon: ({ active }: IconProps) => JSX.Element
  onClick: () => void
}

interface IconProps {
  active?: boolean
  style?: React.CSSProperties
}

const Tab = ({ active, text, Icon, onClick }: TabProps) => {
  return (
    <div
      className={`flex space-x-1 mb-3 md:space-x-6 items-center py-2.5 whitespace-nowrap h-fit  ${
        active ? ' border-b-black' : 'text-gray-400'
      } cursor-pointer`}
      onClick={onClick}
    >
      <div
        className={`flex w-9 h-9 rounded-xl items-center justify-center  ${
          active ? ' bg-black' : 'bg-gray-200 icon-inactive '
        }`}
      >
        <Icon active={active} />
      </div>
      <p className="font-medium text-base md:text-lg leading-7">{text}</p>
    </div>
  )
}

export default Tab
